import React, { useEffect, useState } from "react";
import "./index.css";
import ButtonComponent from "../../../components/ButtonComponent";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
// import { useGetInitialDataQuery } from "../../../redux/services/initialDataService";
// import { useAuth } from "../../../context/AuthContext";
import defaultBackground from "../../../assets/images/Defult.PNG";
import useImageLoader from "../../Home/ImageLoaderHook";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightDots } from "@fortawesome/free-solid-svg-icons";
import { initialData } from "../../../redux/services/initialDataService";
import { useSelector } from "react-redux";

const Dashboard01 = () => {
  const navigate = useNavigate();

  // const { isAuthenticated, isLoading: authLoading } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isHeroImageLoaded, setIsHeroImageLoaded] = useState(false);

  const handleClickNavigate = () => {
    navigate("/order");
  };

  // const { data: initialData } =
  //   useGetInitialDataQuery(undefined, { skip: !isAuthenticated });
  const initialData: initialData = useSelector(
    (state: any) => state.initialData
  );

  const heroImageUrl = initialData?.home?.topBanner?.imageUrl;
  const { isLoaded: isHeroLoaded, error: heroError } =
    useImageLoader(heroImageUrl);

  // const isHeroReady = !authLoading && isHeroLoaded;
  const isHeroReady = isHeroLoaded;
  //Preload hero image on component mount + when initialData changes
  useEffect(() => {
    if (!initialData?.home?.topBanner?.imageUrl) return;

    const img = new Image();
    img.src = initialData.home.topBanner.imageUrl;
    img.onload = () => setIsHeroImageLoaded(true);
    img.onerror = () => setIsHeroImageLoaded(true);

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [initialData]);

  return (
    <>
      <header
        className="hero"
        style={{
          background: heroError
            ? `url(${defaultBackground}) no-repeat center center/cover`
            : `url(${heroImageUrl || defaultBackground
            }) no-repeat center center/cover`,
          transition: "opacity 0.5s ease",
          opacity: isHeroReady ? 1 : 0,
        }}
      >
        <Container className="text-start">
          <h1>{initialData?.home?.topBanner?.textOverlay?.title}</h1>
          <p>{initialData?.home?.topBanner?.textOverlay?.description}</p>
        </Container>
        <Container className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-2">
            <ButtonComponent
              title="Explore Menu"
              backgroundColor="#FF1001"
              onClick={handleClickNavigate}
              icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            />
          </div>
        </Container>
      </header>
    </>
  );
};

export default Dashboard01;
